/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PromptRequest } from './PromptRequest';
import {
    PromptRequestFromJSON,
    PromptRequestFromJSONTyped,
    PromptRequestToJSON,
} from './PromptRequest';

/**
 * 
 * @export
 * @interface PromptLog
 */
export interface PromptLog {
    /**
     * 
     * @type {string}
     * @memberof PromptLog
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLog
     */
    prompt_id: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLog
     */
    user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLog
     */
    user_role?: string;
    /**
     * 
     * @type {number}
     * @memberof PromptLog
     */
    date: number;
    /**
     * 
     * @type {number}
     * @memberof PromptLog
     */
    duration: number;
    /**
     * 
     * @type {PromptRequest}
     * @memberof PromptLog
     */
    request: PromptRequest;
    /**
     * 
     * @type {string}
     * @memberof PromptLog
     */
    response?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLog
     */
    thinking?: string;
    /**
     * 
     * @type {number}
     * @memberof PromptLog
     */
    ttl?: number;
    /**
     * 
     * @type {string}
     * @memberof PromptLog
     */
    tenant_id?: string;
}

/**
 * Check if a given object implements the PromptLog interface.
 */
export function instanceOfPromptLog(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prompt_id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "duration" in value;
    isInstance = isInstance && "request" in value;

    return isInstance;
}

export function PromptLogFromJSON(json: any): PromptLog {
    return PromptLogFromJSONTyped(json, false);
}

export function PromptLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'prompt_id': json['prompt_id'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'user_role': !exists(json, 'user_role') ? undefined : json['user_role'],
        'date': json['date'],
        'duration': json['duration'],
        'request': PromptRequestFromJSON(json['request']),
        'response': !exists(json, 'response') ? undefined : json['response'],
        'thinking': !exists(json, 'thinking') ? undefined : json['thinking'],
        'ttl': !exists(json, 'ttl') ? undefined : json['ttl'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
    };
}

export function PromptLogToJSON(value?: PromptLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'prompt_id': value.prompt_id,
        'user_id': value.user_id,
        'user_role': value.user_role,
        'date': value.date,
        'duration': value.duration,
        'request': PromptRequestToJSON(value.request),
        'response': value.response,
        'thinking': value.thinking,
        'ttl': value.ttl,
        'tenant_id': value.tenant_id,
    };
}

